import React from 'react';
import { Text } from '@bufferapp/ui';
import {
  Checkmark,
  Color,
  IconWrapper,
  LabelWrapper,
  TextWrapper,
} from './styles';

type ItemLabelProps = {
  name: string;
  color?: string;
  isSelected: boolean;
};

export const CampaignItemLabel = ({
  name,
  color,
  isSelected,
}: ItemLabelProps): JSX.Element => (
  <LabelWrapper title={name}>
    <IconWrapper>{isSelected && <Checkmark />}</IconWrapper>
    {color && <Color color={color} />}
    <TextWrapper>
      <Text>{name}</Text>
    </TextWrapper>
  </LabelWrapper>
);
